var map = {
	"./bell.mp3": 374,
	"./callring.mp3": 809,
	"./mute.mp3": 112
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94;


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds ^\.\/.*\.mp3$
// module id = 94
// module chunks = 0